import React from 'react';
import { Message, Popup, Loader } from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import './ResultRenderer.css';

function HighlightedPath({ fullPath, name }) {
  const parts = fullPath.split(name);

  return (
    <span className="full-path">
      {parts.map((part, index) => {
        return (
          <React.Fragment key={part.toString()}>
            {part}
            {index < parts.length - 1 && <span className="highlight">{name}</span>}
          </React.Fragment>
        );
      })}
    </span>
  );
}

function TruncatedPath({ fullPath, name }) {
  const maxWidth = 920;
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = '13px Roboto';

  let truncatedPath = fullPath;
  let { width } = context.measureText(truncatedPath);

  while (width > maxWidth) {
    truncatedPath = truncatedPath.slice(0, -1);
    width = context.measureText(`${truncatedPath}...`).width;
  }

  if (truncatedPath !== fullPath) {
    truncatedPath += '...';
  }

  const showPopup = truncatedPath !== fullPath;

  return (
    showPopup ? (
      <Popup
        content={fullPath}
        trigger={<span><HighlightedPath fullPath={truncatedPath} name={name} /></span>}
      />
    ) : (
      <HighlightedPath fullPath={truncatedPath} name={name} />
    )
  );
}

function ResultRendererWithPath(props) {
  const {
    results, handleResultSelect, isShowResult, handleScroll, translate, isLoadingFileScroll
  } = props;

  const options = results.map((item) => {
    return (
      <div className="result" key={item.id} onMouseDown={(e) => { return handleResultSelect(e, item); }}>
        <Message className="content">
          <TruncatedPath fullPath={item.full_path} name={item.name} />
        </Message>
      </div>
    );
  });

  return (
    <div
      className={cx('results custom path', {
        visible: isShowResult
      })}
    >
      <Scrollbars
        renderTrackHorizontal={() => { return <div />; }}
        renderThumbHorizontal={() => { return <div />; }}
        autoHeight
        autoHeightMin={0}
        autoHeightMax={180}
        onScroll={handleScroll}
      >
        {options.length !== 0 ? (options) : (
          <Message className="empty">
            <Message.Header>{translate('knowledgebase.message.no_results_found')}</Message.Header>
          </Message>
        )}
        {isLoadingFileScroll && (
          <Loader active={isLoadingFileScroll} size="small" inline="centered" />
        )}
      </Scrollbars>
    </div>
  );
}

export default ResultRendererWithPath;
